angular.module("push_notifications")

    .controller("PushNotificationsListCtrl", ['LoginService', '$rootScope', '$scope', '$q', 'Restangular', 'gridService', 'treeService', 'modalService', '$filter', '$state', 'logService',
        function (LoginService, $rootScope, $scope, $q, Restangular, gridService, treeService, modalService, $filter, $state, logService) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = true // LoginService.permissionExist("MAILINGS_WRITE");
            let filter = false;
            $scope.notificationFilter = {};

            $rootScope.title = $filter('translate')('push_notifications.title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('push_notifications.title') }
            ];

            $scope.gridOptions = {
                pdfTitle: $filter('translate')('push_notifications.title'),
                exporterMenuCsv: true,
                gridMenuShowHideColumns: false,
                paginationPageSizes: [15, 30, 45],
                paginationPageSize: 15,
                // rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },

                columnDefs: [

                    {
                        name: 'created_at', displayName: $filter('translate')('user_notifications.date'), type: 'date', cellFilter: 'toLocalDate | date:\'dd/MM/yyyy HH:mm\'',
                        customFormatFn: function (value) {
                            if (value !== null) {
                                var fecha = new Date(value);
                                return $filter('date')(fecha, 'dd/MM/yyyy');
                            }
                            return "";
                        },
                       enableColumnMenu: false, enableFiltering: true, enableHiding: false },
                    { name: 'event_name', displayName: $filter('translate')('user_notifications.event_name'), enableFiltering: true, enableHiding: false },
                    { name: 'title', displayName: $filter('translate')('general.title'), enableFiltering: true, enableHiding: false },
                    { name: 'FK_un_users_notifications_types.name', displayName: $filter('translate')('user_notifications.type'), enableFiltering: true, enableHiding: false },
                    {
                        name: 'is_urgent', displayName: $filter('translate')('user_notifications.priority'), enableFiltering: true, enableHiding: false, enableColumnMenu: false,
                        cellTemplate: '<div class="ui-grid-cell-contents"> <span class= "label label-meddium label-danger">{{row.entity.is_urgent == true? "Urgente" : "" }}</span></div>'
                    },
                    {
                        name: 'status', displayName: $filter('translate')('user_notifications.status'), enableFiltering: true, enableHiding: false, enableColumnMenu: false,
                        cellTemplate: '<div class="ui-grid-cell-contents"><div class="col-sm-1" popover-placement="top" popover-append-to-body="true" popover-trigger="mouseenter" uib-popover="' + $filter('translate')('notifications.sent') + '">' +
                            '<span class= "label label-meddium label-primary">{{row.entity.sent}}</span></div><div class="col-sm-1" popover-placement="top" popover-append-to-body="true" popover-trigger="mouseenter" uib-popover="' + $filter('translate')('notifications.sending') + '">' +
                            '<span class="label label-meddium label-default">{{row.entity.pending}}</span></div><div class="col-sm-1" popover-placement="top" popover-append-to-body="true" popover-trigger="mouseenter" uib-popover="' + $filter('translate')('notifications.sent_error') + '">' +
                            '<span class="label label-meddium label-danger">{{row.entity.error}}</span></div></div >'

                    },
                    {
                        name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('notifications.button_view'), action: 'ui-sref="push_notifications.edit({notificationId:row.entity.id})"', cssIconClass: "fa fa-eye" },
                        ], { cssClass: "pull-right" })
                    },
                ],
                getData: function (options) {

                    
                    if (filter) {

                        options.title = $scope.notificationFilter.title;
                        options.type = $scope.notificationFilter.type;
                        options.event_name = $scope.notificationFilter.event_name;


                    };
                    
                   return Restangular.all('PushNotifications/List').getList(options).then(function (result) {
 
                       //Contamos el estado de cada comunicación con respecto a cada usuario
                        let list = result;
                        list.forEach(l => {
                           l.sent = 0;
                           l.pending = 0;
                           l.error = 0;
                           l.FK_users_notifications_notifications.forEach(user => {
                               switch (user.status) {
                                   case "sent":
                                       l.sent++;
                                       break;
                                   case "pending":
                                       l.pending++;
                                       break;
                                   case "error":
                                       l.error++;
                                       break;
                               }
                           })
                           logService.debug(l)
                       })
                        return list;
                    })
               
                   
                }

            };

            $scope.search = function () {
                filter = true;
                $scope.gridOptions.loadData();
            }

            $scope.goToEdit = function (rowEntity) {
                $state.go("push_notifications_types.edit", { id: rowEntity.id });
            }

            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('push_notifications.delete'),
                    message: $filter('translate')('push_notifications.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('PushNotifications/List', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('push_notifications.remove_success'));
                            $scope.gridOptions.data =
                                $scope.gridOptions.data.filter(function (el) { return el.id != $scope.id; });
                        }, function (response) {
                            logService.error("Error with status code", response.status);
                        });

                    }
                });

            };

        }])

    ;